<!-- 成功案例 -->
<template>
    <div class="case_wrapper">
        <!-- part1 -->
        <div class="section_item case_section1 platform_section1">
            <div class="wrapper">
                <div class="block">
                    <div class="title">{{section1.title}}</div>
                    <div class="description">{{section1.description}}</div>
                    <el-button @click="bind_toggle_form('cooperation')" type="warning" class="btn_init">{{section1.cta}}</el-button>    
                </div> 
                <img :src="section1.link" alt="">
            </div>
        </div>
        <!-- part2 -->
        <div class="section_item case_section2">
            <div class="option_wrapper">
                <el-select 
                    v-model="val_industry" 
                    @change='bind_record_industry'
                    placeholder="全部投放行业"
                    class="option">
                    <el-option
                        v-for="item in section2.industry"
                        :key="item.key"
                        :label="item.val"
                        :value="item.val">
                    </el-option>
                </el-select>
            </div>
            <div class="card_wrapper">
                <div 
                    v-for="(item, idx) in case_list_show" 
                    :key="idx"
                    class="card_item"
                    @click="bind_jump_content(item)">
                    <div class="img"><img :src="item.link" alt=""></div>
                    <div class="desc_wrapper">
                        <div class="title">{{item.title}}</div>
                        <div class="description">{{item.description}}</div>
                        <div class="data_wrapper">
                            <div
                                v-for="(item_tags, idx_tags) in item.tags" 
                                :key="idx_tags"
                                class="data_item">
                                <div class="num">{{item_tags.num}}</div>
                                <div class="tag">{{item_tags.tag}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-button 
                @click='bind_getMore'
                type="warning" 
                class="more btn_init">查看更多案例</el-button> 
        </div>
        <!-- part3 -->
        <div class="section_item case_section3">
            <div class="form_wrapper">
                <CmsForm/>
            </div>
        </div>
        <BottomMsg/>
    </div>    
</template>

<script>
    import Swiper from 'swiper';
    import CmsForm from '@/components/CmsForm';
    import BottomMsg from '@/components/BottomMsg';
    import data from '@/data/case.js';
    import constant from '@/util/constant';
    import axios from 'axios';
    export default {
        name: "Index",
        components: {
            CmsForm,
            BottomMsg
        },
        computed: {
            section1() {
                return data && data.section1;
            },
            section2() {
                return data && data.section2;
            },
            // case_list() {
            //     return data && data.section2.data;
            // }
        },
        data() {
            return {
                // 展示的卡片列表
                case_list_show: [],
                // 选择的投放行业
                val_industry: '',
                // 选择的投放目的
                val_purpose: ''
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                // vm.bind_update_scroll();
                // 由于首页可以直接通往案例详情页，所以后退时候需要定位到首页中轮播图的位置
                if (from.path.indexOf('case_content') > -1) {
                    setTimeout(() => {
                        let scrollT = localStorage.getItem('scrollT');
                        window.scrollTo(0, scrollT);
                        localStorage.removeItem('scrollT');
                    }, 500)
                }
            });
        },
        mounted() {
            axios.get(`${constant.CMS_ADS}/dsp/ow_case.json?3`).then((res) => {
                this.case_list = res.data;
                // 初始化需要展示的案例
                this.case_list_show = 
                    this.case_list.length >=9 ? 
                    (this.case_list.slice(0, 9)): 
                    (this.case_list.slice(0));
            })
        },
        methods: {
            // 统计行业点击记录
            bind_record_industry(val) {
                // 百度统计
                // window._hmt.push(['_trackEvent', 'case', 'select_industry', val]);
                if (val == '全部') {
                    this.case_list_show = this.case_list.length >=9 ? 
                    (this.case_list.slice(0, 9)): 
                    (this.case_list.slice(0));
                } else {
                    this.case_list_show = this.case_list.filter((item) => {
                        return item.type && item.type.indexOf(val) > -1;
                    })
                }
            },
            // 统计目的点击记录
            bind_record_purpose(val) {
                // 百度统计
                // window._hmt.push(['_trackEvent', 'case', 'select_purpose', val]);
            },
            // 获取更多案例
            bind_getMore() {
                // 百度统计
                // window._hmt.push(['_trackEvent', 'case', 'more']);
                console.log(this.val_industry);
                let current_list = this.val_industry == '全部' ? this.case_list : this.case_list.filter((item) => {
                    return item.type && item.type.indexOf(this.val_industry) > -1;
                });
                let ori_len = this.case_list_show.length;
                let total_len = current_list.length;
                if (total_len > ori_len) {
                    // 如果已有案例数量大于已展示案例数量，则展示数量+3
                    this.case_list_show = this.case_list_show.concat(current_list.slice(ori_len, ori_len+3));
                } else {
                    this.$message({
                        message: '已经没有啦',
                        center: true,
                        type: 'error',
                        customClass: 'msg_center',
                        duration: 1000
                    })
                }
            },
            // 获取具体文章内容
            bind_jump_content(idx) {
                // 记录这个滚动距离
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                localStorage.setItem('scrollT', scrollTop);
                window._hmt.push(['_trackEvent', 'case_detail', JSON.stringify(idx)]);
                this.$router.push({
                    path: `case_content/${idx.name_en}`
                })
            },
            // 显示合作/登录组件
            bind_toggle_form(flag) {
                // 百度统计
                window._hmt.push(['_trackEvent', 'ctaTrigger', 'case', flag]);
                this.$emit('toggleForm', flag);
            }
        }
    }
</script>

<style scoped>
    /* 整个首页的包裹样式 */
    .case_wrapper {
        min-width: 1280px;
        text-align: center;
        overflow: auto;
        font-size: 0;
    }
    /* 第一部分的样式 */
    .case_section1 {
        background: linear-gradient(0deg, #f5f9ff 0%, #fcfdff 100%);
        background: #fcfdff\9\0;
        overflow: hidden;
    }
     /* 第二部分的样式 */
    .case_section2 {
        background: #f7f8fa;
        height: auto;
    }
    /* 选择框包裹狂 */
    .case_section2 .option_wrapper {
        width: 1280px;
        margin: 0 auto;
        margin-top: 48px;
        text-align: left;
    }

    .option_wrapper .option {
        width: 400px;
        margin-right: 40px;
    }
    /* 列表包裹狂 */
    .case_section2 .card_wrapper {
        width: 1280px;
        font-size: 0;
        margin: 0 auto;
        margin-top: 31px;
        overflow: hidden;
    }

    .card_wrapper .card_item {
        width: 400px;
        height: 400px;
        background: #fff;
        border-radius: 4px;
        margin-bottom: 41px;
        margin-right: 40px;
        float: left;
        cursor: pointer;
        box-shadow: 0 2px 30px 0 rgba(204,230,255,0.36);
        /* animation: shine 0.5s linear; */
        transition: 0.2s linear all;

    }

    .card_wrapper .card_item:hover {
        /* animation: float 0.2s linear forwards; */
        transform: translateY(-10px);
        -ms-transform: translateY(-10px);
        opacity: 0.8;
    }

    .card_wrapper .card_item:nth-child(3n) {
        margin-right: 0px;
    }

    .card_item .img {
        height: 213px;
    }

    .card_item .desc_wrapper {
        padding: 0 24px;
    }

    .card_item .title {
        margin-top: 32px;
        font-size: 18px;
        color: #18253D;
        letter-spacing: 0;
        line-height: 18px;
    }

    .card_item .description {
        margin-top: 16px;
        font-size: 14px;
        color: #A9AEB8;
        letter-spacing: 0;
        line-height: 14px;
    }

    .card_item .data_wrapper {
        margin-top: 25px;
        padding-top: 20px;
        border-top: 1px solid #f0f0f0;
        /* text-align: justify; */
        text-align: center;
        position: relative;
    }

    .data_wrapper .data_item {
        position: absolute;
        top: 25px;
    }

    .data_wrapper .data_item:nth-child(1n) {
        left: 0;
    }

    .data_wrapper .data_item:nth-child(2n) {
        /* float: none; */
        left: 50%;
        transform: translateX(-50%);
        -ms-transform: translateX(-50%);
    }

    .data_wrapper .data_item:nth-child(3n) {
        left: auto;
        right: 0;
    }

    .data_item .num {
        font-family: PingFangSC-Light;
        font-size: 18px;
        color: #18253D;
        letter-spacing: 0;
        line-height: 18px;
    }

    .data_item .tag {
        margin-top: 8px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #A9AEB8;
        letter-spacing: 0;
        line-height: 14px;
    } 

    .data_wrapper:after {
        width: 100%;
        height: 0;
        margin: 0;
        display: inline-block;
        overflow: hidden;
        content: '';
    }
    /* text-align:justify 不处理块内的最后一行文本，手动加上样式 */
    .card_wrapper:after {
        width: 100%;
        height: 0;
        margin: 0;
        display: inline-block;
        overflow: hidden;
        content: '';
    }

    .case_section2 .more {
        margin-bottom: 40px;
    }
    /* 标题包裹狂 */
    .case_section3 .form_wrapper {
        width: 1280px;
        margin: 0 auto;
        margin-top: 48px;
        margin-bottom: 54px;
    }

</style>





// WEBPACK FOOTER //
// src/containers/Case/Case.vue